<script setup>
import { debouncedWatch, onClickOutside } from '@vueuse/core'

defineProps({
  dropdownClass: String,
  triggerClass: String,
  loading: Boolean
})

const isAnimatingScaleDown = ref(false)
const showModel = defineModel({
  type: Boolean,
  default: false
})

debouncedWatch(() => showModel.value, () => {
  toggleShownState()
}, { debounce: 250 })

const show = ref(false)

const dropdown = ref(null)

// Only setup click outside handler on client side to avoid hydration mismatch
if (process.client) {
  onClickOutside(dropdown, () => {
    if (show.value === true) {
      toggleShownState()
    }
  })
}

function toggleShownState () {
  if (show.value === false) {
    show.value = true
    return
  }
  isAnimatingScaleDown.value = true
  setTimeout(() => {
    show.value = false
    isAnimatingScaleDown.value = false
  }, 180)
}
</script>

<template>
  <div
    ref="dropdown"
    class="dropdown relative w-fit transition-opacity"
    :class="{ 'pointer-events-none opacity-50': loading }">
    <button
      id="trigger"
      :class="triggerClass"
      @click="toggleShownState">
      <slot
        name="trigger"
        :is-open="show" />

      <LoadingSpinner
        v-if="loading"
        class="absolute right-6 top-3.5 !size-4" />
    </button>
    <AppCard
      v-if="show"
      class="absolute right-0 z-30 mt-1 w-fit min-w-52 overflow-auto transition-transform duration-[180ms] peer-checked:flex "
      :class="[
        dropdownClass,
        {
          'scale-[0.94] animate-[scaleUp_0.18s_ease-out_forwards] ': !isAnimatingScaleDown,
          'scale-100 animate-[scaleDown_0.18s_ease-out_forwards]': isAnimatingScaleDown
        }
      ]">
      <slot />
    </AppCard>
  </div>
</template>
